import Moment from 'moment';
export const Filters = {
  filters: {
    currency(value) {
      if (value) {
        if (value !== undefined) {
          return value
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
        }
      }
      return '0';
    },
    dateFormat(value) {
      return Moment(value).format('DD-MM-YYYY');
    },
    diffDate(date, now = Moment()) {
      if (date) {
        const before = Moment(date);
        return now.diff(before, 'minutes');
      }
      return '';
    },
    hourFormat(value) {
      return Moment(value).format('LT');
    },
    upperCase(value) {
      return value.toUpperCase();
    },
  },
};
